import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">Copyright &copy; Machaxi</p>
      </div>
    </footer>
  );
};

export default Footer;
